import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

import { environment } from 'environments/environment';
import { of, ReplaySubject } from 'rxjs';
import { concatMap, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SpAuthMfaService {
  /*** Observable cache for Employee Profile. */
  private mfaAccessTokenSubject = new ReplaySubject<string>(1);
  mfaAccessToken = '';
  /*** Observable used to connect to observable cache. */
  mfaAccessTokenSilently$ = this.mfaAccessTokenSubject.asObservable();

  error$ = this.auth0.error$;

  authIds$ = this.auth0.idTokenClaims$.pipe(
    filter(claims => !!claims),
    concatMap(claims => {
      return of({
        bcl: `${claims['http://www.surepayroll.com/bcl']}`,
        secLoginId: `${claims['http://www.surepayroll.com/sec_login']}`,
        programCode: `${claims['http://www.surepayroll.com/program_code']}`,
        partnerCode: `${claims['http://www.surepayroll.com/partner_code']}`,
      });
    })
  );

  mfa$ = this.auth0.idTokenClaims$.pipe(
    filter(claims => !!claims),
    concatMap(claims => {
      return of({
        isMfa: claims['amr'] && 'mfa' === `${claims['amr'][0]}`,
        isTriggeredByApp: `${claims['http://www.surepayroll.com/challenge_id']}` !== 'undefined',
      });
    })
  );

  isAuthenticated$ = this.auth0.isAuthenticated$;
  tokenClaims$ = this.auth0.idTokenClaims$;
  constructor(private auth0: AuthService) {}

  loginWithRedirect = () => this.auth0.loginWithRedirect();
  logout = () => this.auth0.logout();

  RetrieveMfaAccessToken(auth0: AuthService) {
    this.auth0 = auth0;
    this.GetTokenSilently();
  }

  RedirectToGetMfa() {
    console.log('In RedirectToGetMfa...');
    this.auth0
      .loginWithRedirect({
        redirect_uri: window.location.origin + '/ess' + '/account-management',
        audience: environment.audienceMfa,
        scope:
          'openid profile email offline_access enroll read:authenticators remove:authenticators',
        detailedResponse: false,
        isMfaRedirect: true,
        appState: { target: 'account-management/' },
      })
      .subscribe(s => console.log('In Subscribe of loginWithRedirect', s));
  }

  public get isSigninMfaRedirectCallback() {
    const search = window.location.search;
    const path = window.location.pathname || '';
    return (
      (search.includes('code=') || search.includes('error=')) &&
      search.includes('state=') &&
      path.includes('/account-management/')
    );
  }

  public tokenExpired(token: string) {
    if (token?.length > 0) {
      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      const totalTime = decodedToken.exp - decodedToken.iat;
      const timeRemaining = decodedToken.exp - Math.floor((new Date).getTime() / 1000);
      const percentage = (timeRemaining * 100) / totalTime;
      console.log(percentage);
      return percentage <= 20;
    }
    return true;
  }

  GetTokenSilently(): boolean {
    let redirectToGetMfa = false;
    if (this.mfaAccessToken?.length > 0 && !this.tokenExpired(this.mfaAccessToken)) {
      return redirectToGetMfa;
    }
    this.auth0
      .getAccessTokenSilently({
        audience: environment.audienceMfa,
        scope:
          'openid profile email offline_access enroll read:authenticators remove:authenticators',
        detailedResponse: true,
        isMfaRedirect: true,
      })
      .subscribe({
        next: mfaAccessTokenSilently => {
          console.log('In Success of getToken Silently');
          const obj = mfaAccessTokenSilently as any; // what comes back from getAccessTokenSilently() is not really a string. blows up when trying to do a .split()
          let token = '';
          if ('access_token' in obj) {
            token = obj['access_token'];
            this.mfaAccessToken = token;
          } else {
            token = obj as string;
            this.mfaAccessToken = obj as string;
          }

          this.mfaAccessTokenSubject.next(token);
        },
        error: err => {
          console.log('In Error of getToken Silently');
          console.error(err.message);
          if ('Multifactor authentication required' == err.message) {
            console.log('isSigninMfaRedirectCallback = ', this.isSigninMfaRedirectCallback);
            if (!this.isSigninMfaRedirectCallback) {
              redirectToGetMfa = true;
              console.log('Redirecting to Get MFA...');
              this.RedirectToGetMfa();
            }
          }
        },
      });
    return redirectToGetMfa;
  }
}
